import { StaticBaseDao } from '@/dao';
import { Profile } from '@/objects/generated';

export class ProfileDao extends StaticBaseDao {
    public static async GetProfilesByOrganizer(organizerId: number): Promise<Profile[]> {
        return this.BaseFetchArray(
            Profile,
            `Profile/Organizer` + '?' + (organizerId == undefined ? '' : `organizerId=${organizerId}`),
            'GET',
        );
    }
    public static async SaveProfile(profile: Profile): Promise<Profile | null> {
        return this.BaseFetch(Profile, `Profile/SaveProfile`, 'POST', profile);
    }
}
